import React, {Component} from 'react';
import HelpBubble from 'js/components/help_bubble';
import * as R from 'ramda';
import axios from 'axios';
import {OverlayTrigger, Tooltip} from 'react-bootstrap';

import {truncate} from 'js/common/string_helper';
import * as ObjectHelper from 'js/common/object_helper';

const ReplyText = ({text}) => {
    if (text.length < 100) {
        return <span>{text}</span>;
    }

    const replyShown = truncate(text, 100);

    const tooltip = (
        <Tooltip className="in">
            <span>{text}</span>
        </Tooltip>
    );

    return (
        <span>
            <OverlayTrigger placement="top" overlay={tooltip}>
                <span>{replyShown}</span>
            </OverlayTrigger>
        </span>
    );
};
class SentimentCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            replies: props.replies
        };
    }

    setQueuedForDeletion = (reply, isQueued) => {
        this.setState({
            replies: R.map(
                R.ifElse(
                    R.propEq('id', reply.id),
                    R.assoc('queuedForDeletion', isQueued),
                    R.identity
                ),
                this.state.replies
            )
        });

        if (isQueued) {
            this.props.queue_for_deletion(reply);
        } else {
            this.props.dequeue_for_deletion(reply);
        }
    };

    renderReply = reply => {
        const replyStyle = {
            position: 'relative'
        };
        const overlayStyle = {
            alignItems: 'center',
            backgroundColor: 'rgba(255, 50, 50, 0.8)',
            bottom: 0,
            color: 'white',
            cursor: 'pointer',
            display: 'flex',
            fontWeight: 'bold',
            justifyContent: 'space-between',
            left: '-22px',
            position: 'absolute',
            right: '-15px',
            textAlign: 'center',
            top: '1px'
        };

        if (this.props.is_edit_mode && reply.queuedForDeletion) {
            const iconStyle = {
                flexGrow: '0',
                left: '4px',
                top: '-1px'
            };
            const textStyle = {
                flexGrow: '1',
                left: '-4px',
                position: 'relative'
            };
            return (
                <li
                    key={reply.id}
                    style={replyStyle}
                    onClick={() => this.setQueuedForDeletion(reply, false)}
                >
                    <div style={overlayStyle}>
                        <i className="glyphicon glyphicon-ok" style={iconStyle} />
                        <span style={textStyle}>To be deleted</span>
                    </div>
                    <span className="username">{reply.from.username}</span>
                    &nbsp;
                    <ReplyText text={reply.text} />
                </li>
            );
        } else if (this.props.is_edit_mode) {
            const iconStyle = {
                color: 'red',
                cursor: 'pointer',
                display: 'inline-block',
                left: '-17px',
                position: 'absolute',
                top: '3px'
            };
            return (
                <li key={reply.id} style={replyStyle}>
                    <i
                        className="glyphicon glyphicon-remove"
                        style={iconStyle}
                        onClick={() => this.setQueuedForDeletion(reply, true)}
                    />
                    <span className="username">{reply.from.username}</span>
                    &nbsp;
                    <ReplyText text={reply.text} />
                </li>
            );
        }
        return (
            <li key={reply.id} style={replyStyle}>
                <span className="username">{reply.from.username}</span>
                &nbsp;
                <ReplyText text={reply.text} />
            </li>
        );
    };

    render() {
        const style = {
            backgroundImage: `url(${this.props.image_url})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundColor: 'white'
        };

        const profilePictureStyle = {
            backgroundImage: `url(${this.props.created_by_profile_picture_url})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundColor: 'white',
            width: '36px',
            height: '36px',
            borderRadius: '20px'
        };

        return (
            <div className="consumer-sentiment-card">
                <div className="card-header">
                    <div className="card-header-user-profile-picture" style={profilePictureStyle} />
                    <a
                        href={`https://www.instagram.com/${this.props.created_by}`}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {this.props.created_by}
                    </a>
                </div>
                <div className="post-inner" style={style} />
                <div>
                    <ul className="replies-list">
                        {R.map(this.renderReply, R.values(this.state.replies))}
                    </ul>
                </div>
            </div>
        );
    }
}

class SentimentCardContainer extends Component {
    render() {
        const {posts, is_edit_mode, queue_for_deletion, dequeue_for_deletion} = this.props;
        const cards = R.map(function(post) {
            const {id, top_replies, profile_image_url, thumbnail_url} = post;

            const createdBy = ObjectHelper.pathOr(
                '',
                [
                    'content_distribution_metadata',
                    'snapshots',
                    'platform_account',
                    'platform_handle'
                ],
                post
            );

            const replies = R.map(function(replyId) {
                return R.find(R.propEq('id', replyId))(post.content_distribution_metadata.replies);
            }, top_replies);

            return (
                <SentimentCard
                    key={id}
                    image_url={thumbnail_url}
                    replies={replies}
                    created_by={createdBy}
                    created_by_profile_picture_url={profile_image_url}
                    is_edit_mode={is_edit_mode}
                    queue_for_deletion={queue_for_deletion}
                    dequeue_for_deletion={dequeue_for_deletion}
                />
            );
        }, posts);

        return <div className="consumer-sentiment-card-container">{cards}</div>;
    }
}

class ConsumerSentiment extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isEditMode: false,
            queuedForDeletion: []
        };
    }

    handleReset = () => {
        axios.post(window.sn.squashedCommentsResetUrl).then(() => window.location.reload());
    };

    handleSubmit = () => {
        axios
            .post(window.sn.squashCommentsUrl, {reply_ids: this.state.queuedForDeletion})
            .then(() => window.location.reload());
    };

    queueForDeletion = reply => {
        this.setState({
            queuedForDeletion: R.append(reply.id, this.state.queuedForDeletion)
        });
    };

    dequeueForDeletion = reply => {
        this.setState({
            queuedForDeletion: R.reject(R.equals(reply.id), this.state.queuedForDeletion)
        });
    };

    renderFormButtons() {
        if (!window.sn.isAdmin) {
            return;
        }

        if (this.state.isEditMode) {
            return (
                <div>
                    <button className="btn btn-default" onClick={this.handleReset}>
                        Reset to Default
                    </button>
                    &nbsp;
                    <button className="btn btn-primary" onClick={this.handleSubmit}>
                        Save &amp; Refresh
                    </button>
                </div>
            );
        }
        const iconStyle = {
            cursor: 'pointer'
        };
        return (
            <i
                className="glyphicon glyphicon-pencil"
                style={iconStyle}
                onClick={() => this.setState({isEditMode: true})}
            />
        );
    }

    render() {
        const {renderForPdf, bgColor, consumer_sentiment} = this.props;

        const toolTip = !renderForPdf ? (
            <HelpBubble
                text={
                    'We have partnered with IBM Watson to leverage artificial intelligence to identify positive sentiment across your campaign. Showcased below are some of the key highlights as identified by our sentiment analyzer.'
                }
                inline
                multiline
                place="right"
            />
        ) : null;

        return (
            <div className="consumer-sentiment wrap-up-section">
                <div className="consumer-sentiment-header-container">
                    <div className="top-corner">{this.renderFormButtons()}</div>
                    <div className="consumer-sentiment-header-title">Consumer Sentiment</div>
                    <div className="consumer-sentiment-header-subtitle">
                        See what&apos;s being said about your content.
                        {toolTip}
                    </div>
                </div>

                <SentimentCardContainer
                    posts={consumer_sentiment}
                    is_edit_mode={this.state.isEditMode}
                    queue_for_deletion={this.queueForDeletion}
                    dequeue_for_deletion={this.dequeueForDeletion}
                />

                <style>{`
                    .consumer-sentiment {
                        background-color: ${bgColor};
                        text-align: center;
                        position: relative;
                    }

                    .consumer-sentiment-header-title {
                        font-size: 36px;
                        font-weight: 200;
                        padding-top: 40px;
                    }

                    .consumer-sentiment-header-subtitle {
                        font-size: 20px;
                        font-weight: 200;
                        text-align: center;
                        padding: 10px 0px 40px 0px;
                    }

                    .consumer-sentiment .top-corner {
                        position: absolute;
                        right: 10px;
                        top: 10px;
                    }

                    .card-header {
                        display: table;
                    }

                    .card-header a {
                        display: table-cell;
                        vertical-align: middle;
                        color: black;
                    }
                `}</style>

                {/*STYLE FOR WEB*/}
                {!renderForPdf ? (
                    <style>{`
                        .consumer-sentiment-card-container {
                            padding: 10px;
                            margin: auto;
                            max-height: 1400px;
                            display: flex;
                            flex-wrap: wrap;
                            align-items: center;
                            justify-content: space-around;
                            flex-direction: column;
                        }

                        .consumer-sentiment-card {
                            text-align: left;
                            display: flex;
                            flex-direction: column;
                            margin: 1%;
                            width: 21%;
                            position: relative;
                            border-radius: 20px;
                            background-color: white;
                            box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2);
                            flex: 0 1 auto;
                        }

                        .consumer-sentiment-card .card-header {
                            font-weight: bold;
                            font-size: 14px;
                            margin: 9px;
                        }

                        .consumer-sentiment-card .card-header .card-header-user-profile-picture {
                            margin-right: 13px;
                            float: left;
                        }

                        .consumer-sentiment-card .replies-list {
                            list-style: none;
                            padding-left: 22px;
                            padding-right: 15px;
                            padding-top: 13px;
                            padding-bottom: 19px;
                            word-break: break-word;
                        }

                        .consumer-sentiment-card .replies-list .username {
                            font-weight: bold;
                        }

                        .consumer-sentiment-card .post-inner {
                            height: auto;
                            width: 100%;
                        }

                        .consumer-sentiment-card .post-inner:before {
                            content: no-open-quote;
                            float: left;
                            padding-top: 100%;
                        }

                        .consumer-sentiment-card .post-inner:after {
                            content: no-close-quote;
                        }
                    `}</style>
                ) : null}

                {/*STYLE FOR PDF*/}
                {renderForPdf ? (
                    <style>{`
                        .consumer-sentiment {
                            padding-top: 20px;
                            page-break-before: always;
                        }

                        .consumer-sentiment-card {
                            display: inline-block;
                            vertical-align: top;

                            text-align: left;

                            margin: 1%;
                            width: 21%;
                            position: relative;
                            border-radius: 20px;
                            background-color: white;
                            box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2);

                            overflow: hidden;
                        }

                        .consumer-sentiment-card .card-header {
                            font-weight: bold;
                            font-size: 14px;
                            margin: 9px;
                            padding-bottom: 10px;
                        }

                        .consumer-sentiment-card .card-header .card-header-user-profile-picture {
                            margin-right: 13px;
                            float: left;
                        }

                        .consumer-sentiment-card .post-inner {
                            width: 100%;
                            height: 200px;
                        }

                        .consumer-sentiment-card .replies-list {
                            list-style: none;
                            padding-left: 22px;
                            padding-right: 15px;
                            padding-top: 13px;
                            padding-bottom: 19px;
                            word-break: break-word;
                            max-height: 250px;
                            overflow: hidden;
                        }

                        .consumer-sentiment-card .replies-list .username {
                            font-weight: bold;
                        }
                    `}</style>
                ) : null}
            </div>
        );
    }
}

export default ConsumerSentiment;



// WEBPACK FOOTER //
// ./campaign_analytics/campaign_wrap_up/consumer_sentiment/index.js